import React from "react";
import classNames from "classnames";
import { ellipseColor } from "./ellipseColor/ellipseColor";
import { Theme, LoaderEmphasis } from "./types";
import styles from "./loader.module.scss";

export type LoaderProps = {
  className?: string;
  /**
   * Determines the style of the loader
   */
  emphasis?: LoaderEmphasis;
  /**
   * Controls the size of the loader
   */
  size?: "xsmall";
  /**
   * Controls the theme of the loader
   */
  theme?: Theme;
};

const Loader = ({
  className,
  emphasis = "default",
  size = "xsmall",
  theme = "core",
  ...props
}: LoaderProps) => {
  const ellipses = [1, 2, 3];

  return (
    <figure
      className={classNames(styles.baseLoader, className)}
      data-size={size}
      {...props}
    >
      {ellipses.map((ellipse) => (
        <div
          data-emphasis={emphasis}
          data-size={size}
          className={classNames(
            styles.baseEllipse,
            ellipseColor({ theme, emphasis })
          )}
          key={ellipse}
        />
      ))}
    </figure>
  );
};

export default Loader;
